import { API_BASE } from '@/Module/Core/Constant';

export const NOTIFICATION_API = {
  GET_LIST_NOTIFICATION: `${API_BASE}/notification-histories/current-user`,
  GET_READ_NOTIFICATION: `${API_BASE}/notification-histories/{id}/read`,
  GET_READ_ALL_NOTIFICATION: `${API_BASE}/notification-histories/read-all`,
  GET_TOTAL_NOTIFICATION: `${API_BASE}/notification-histories/status/current-user`,
};
